<nav mat-tab-nav-bar [tabPanel]="tabPanel">
    <div class="container">
      <div class="d-flex">
        <a mat-tab-link [routerLink]="'/admin/administration-panel/tools-configuration'" routerLinkActive
          #rla1="routerLinkActive" [active]="rla1.isActive">
          {{ "toolsConfiguration.toolsConfiguration" | translate }}
        </a>
        <a mat-tab-link [routerLink]="'/admin/administration-panel/application-permissions'" routerLinkActive
          #rla2="routerLinkActive" [active]="rla2.isActive">
          {{ "AdministrationPanel.toolsPermissionsForGroups" | translate }}
        </a>
        <a mat-tab-link [routerLink]="'/admin/administration-panel/applications-management'" routerLinkActive
          #rla3="routerLinkActive" [active]="rla3.isActive">
          {{ "applicationsManagement.applicationsManagement" | translate }}
        </a>
        <a mat-tab-link [routerLink]="'/admin/administration-panel/environments-configuration'" routerLinkActive
          #rla4="routerLinkActive" [active]="rla4.isActive">
          {{ "environmentsConfiguration.environmentsConfiguration" | translate }}
        </a>
        <a mat-tab-link [routerLink]="'/admin/administration-panel/audit-logs'" routerLinkActive
          #rla5="routerLinkActive" [active]="rla5.isActive">
          {{ "auditLogs.auditLogs" | translate }}
        </a>
      </div>
    </div>
  </nav>

  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
